import { InjectionToken } from '@angular/core';
import * as _urlTemplate from 'url-template';

export type TemplateParser = typeof _urlTemplate;
export type Template = ReturnType<typeof _urlTemplate.parse>;

export const TEMPLATE_PARSER: InjectionToken<TemplateParser> = new InjectionToken<TemplateParser>(
  'TemplateParserToken'
);
